import ApiBase from "./ApiBase";

export default class MyCampusEdossier {

    static load = function (query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.getData("/" + window.HSLU.scLanguage + "/api/EdossierList/Load2", query, successCallback, errorCallback, alwaysCallback);
    }
}